import * as React from 'react'
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { MdTimer } from 'react-icons/md'
import { IVolumetricFlowController } from './types'

// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';

export const ConfigurationPanel = (props: IVolumetricFlowController) => {

    const [errDelay, setErrDelay, setErrDelayResult] = useSetObjectValue(props.id,props.resourceGroupId, "errDelay", props.errDelay);
    const onValueChanged = (e: any) => setErrDelay(parseFloat(e.target.value));

    return (
        <FormControl
            label={<FormattedMessage id="Devices.AlarmDelay" defaultMessage="Alarm Delay" />}
            caption={<FormattedMessage id="Devices.TextAlarmDelay" defaultMessage="delay until an alarm is generated" />}
            error={setErrDelayResult.isError}
        >
            <Input
                value={errDelay}
                onChange={onValueChanged}
                startEnhancer={<MdTimer />}
                endEnhancer='sec'
                type='number'
            />
        </FormControl>
    )
}
